// src/components/seo/StructuredData.jsx

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getSchemaAvailability } from '../../utils/productStock';

export const OrganizationStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Felicita Fragrances",
    "alternateName": "Felicita Parfüm Şişeleri",
    "url": "https://www.felicitafragrances.com",
    "logo": "https://www.felicitafragrances.com/logo192.png",
    "description": "Türkiye'nin en kaliteli parfüm şişeleri, esanslar ve parfüm yapım malzemeleri satışı. Lüks ambalaj çözümleri ve uygun fiyatlar.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "TR",
      "addressRegion": "İstanbul",
      "addressLocality": "İstanbul"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "areaServed": "TR",
      "availableLanguage": "Turkish"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Turkey"
    },
    "knowsAbout": [
      "parfüm şişeleri",
      "boş parfüm şişesi",
      "parfüm ambalajı",
      "lüks parfüm şişesi",
      "kolonya şişesi",
      "cam parfüm şişesi",
      "parfüm esansları",
      "parfüm yapımı",
      "parfüm kapaği"
    ],
    "sameAs": []
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export const ProductStructuredData = ({ product }) => {
  if (!product) return null;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.description || product.name,
    "image": product.imageUrl || product.image,
    "sku": product.id,
    "brand": {
      "@type": "Brand",
      "name": "Felicita Fragrances"
    },
    "offers": {
      "@type": "Offer",
      "price": product.price,
      "priceCurrency": "TRY",
      "availability": getSchemaAvailability(product),
      "seller": {
        "@type": "Organization",
        "name": "Felicita Fragrances"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export const BreadcrumbStructuredData = ({ items }) => {
  if (!items || items.length === 0) return null;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://www.felicitafragrances.com${item.url}`
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export const WebsiteStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Felicita Fragrances",
    "url": "https://www.felicitafragrances.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.felicitafragrances.com/products?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};